export default "__VITE_ASSET__DZ899IHO__"